import { DynamicComponents } from './DynamicComponents';

export type { TypeDynamicComponentsProps } from './types';
export default DynamicComponents;
